import React, { FunctionComponent } from 'react';
import { PersonShowModalHistoriesState } from './types';
import { TextBox } from '../../atoms/textBox';
import { TextArea } from '../../atoms/textArea';
import { CareerEmploymentType } from '../../../types/personShow';
import { CAREER_EMPLOYMENT_TYPE_EXECUTIVE, CAREER_EMPLOYMENT_TYPE_FREELANCE, CAREER_EMPLOYMENT_TYPE_PUBLICOFFICER } from './constants';

type Props = {
  state: PersonShowModalHistoriesState;
  startYearList: number[];
  birthdayList: number[];
  careerEmploymentTypes?: CareerEmploymentType[];
  target: string;
  fromEntry?: boolean;
  onChangeBody: (name: keyof PersonShowModalHistoriesState, value: any) => void;
  onChangeEmploymentSpecial: (type: string, checked: boolean) => void;
  handleOpenSmallModal: (index: number) => void;
  handleDeleteOccuption: (index: number) => void;
  handleAddOccuption: () => void;
  handleScrollTo: (name: string) => void;
  isCheckedPosition: (parent: boolean, value: string | number) => boolean;
  salaryWord: () => string;
  handleClickOccupations: (occupationName: string, occupationDetailId: number | string, occupationDetailName: string) => void;
  handleCloseSmallModal: () => void;
  handleOpenSmallSubModal: () => void;
  handleClearSalary: () => void;
  handleCloseSmallSubModal: () => void;
  onChangeDate: (name: keyof PersonShowModalHistoriesState, event: React.ChangeEvent<HTMLSelectElement>) => void;
  handleDeleteHistories: () => void;
};

export const Presentation: FunctionComponent<Props> = ({
  state,
  startYearList,
  birthdayList,
  careerEmploymentTypes,
  target,
  fromEntry,
  onChangeBody,
  onChangeEmploymentSpecial,
  handleOpenSmallModal,
  handleDeleteOccuption,
  handleAddOccuption,
  handleScrollTo,
  isCheckedPosition,
  salaryWord,
  handleClickOccupations,
  handleCloseSmallModal,
  handleOpenSmallSubModal,
  handleClearSalary,
  handleCloseSmallSubModal,
  onChangeDate,
  handleDeleteHistories,
}) => {
  return (
    <div className="person__show__modal__inner">
      <p className="person__show__modal__inner--title">
        {state.title}
      </p>

      <div className="person__show__modal__inner__box">
        <p className="person__show__modal__inner--semititle">
          {state.semititleFirst}
          <span className="must">必須</span>
        </p>
        <TextBox
          className="person__show__modal__inner--textbox"
          placeholder={
            target === 'educationalHistories'
              ? '〇〇大学'
              : '株式会社READY TO FASHION'
          }
          onChanged={(name, value) => onChangeBody('name', value)}
          name="name"
          value={state.name}
        />
      </div>

      {target === 'careerHistories' ? (
        <>
          {/* 雇用形態 */}
          <div className="person__show__modal__inner__box">
            <p className="person__show__modal__inner--semititle">
              雇用形態<span className="must">必須</span>
            </p>
            <select
              className="person__show__modal__inner--select fit-content"
              name="employmentType"
              value={state.careerEmploymentTypeId ?? ''}
              onChange={(e) => onChangeBody('careerEmploymentTypeId', e.target.value === '' ? null : Number(e.target.value))}
              disabled={
                state.careerEmploymentTypeId === CAREER_EMPLOYMENT_TYPE_EXECUTIVE ||
                state.careerEmploymentTypeId === CAREER_EMPLOYMENT_TYPE_FREELANCE ||
                state.careerEmploymentTypeId === CAREER_EMPLOYMENT_TYPE_PUBLICOFFICER
              }
            >
              <option value="">選択してください</option>
              {(careerEmploymentTypes ?? []).map((opt) => (
                <option
                  key={opt.id}
                  value={opt.id}
                >
                  {opt.name}
                </option>
              ))}
            </select>
            <div className="person__show__modal__inner__box__checkbox-group">
              <p className='person__show__modal__inner__box__other'>その他：</p>
              <label htmlFor="employmentType-executive" className="person__show__modal__inner__box__checkbox">
                <input
                  id="employmentType-executive"
                  type="checkbox"
                  className="checkbox-input"
                  checked={state.careerEmploymentTypeId === CAREER_EMPLOYMENT_TYPE_EXECUTIVE}
                  onChange={(e) =>
                    onChangeEmploymentSpecial('executive', e.target.checked)
                  }
                />
                役員
              </label>
              <label htmlFor="employmentType-freelance" className="person__show__modal__inner__box__checkbox">
                <input
                  id="employmentType-freelance"
                  type="checkbox"
                  className="checkbox-input"
                  checked={state.careerEmploymentTypeId === CAREER_EMPLOYMENT_TYPE_FREELANCE}
                  onChange={(e) =>
                    onChangeEmploymentSpecial('freelance', e.target.checked)
                  }
                />
                フリーランス
              </label>
              <label htmlFor="employmentType-publicOfficer" className="person__show__modal__inner__box__checkbox">
                <input
                  id="employmentType-publicOfficer"
                  type="checkbox"
                  className="checkbox-input"
                  checked={state.careerEmploymentTypeId === CAREER_EMPLOYMENT_TYPE_PUBLICOFFICER}
                  onChange={(e) =>
                    onChangeEmploymentSpecial('publicOfficer', e.target.checked)
                  }
                />
                公務員
              </label>
            </div>
          </div>
          <div className="person__show__modal__inner__box">
            <p className="person__show__modal__inner--semititle">
              {state.semititleSecond}
            </p>
            <TextBox
              className="person__show__modal__inner--textbox"
              placeholder="一般社員"
              onChanged={(name, value) => onChangeBody('department', value)}
              name="department"
              value={state.department}
            />
          </div>
        </>
      ) : (
        <div className="person__show__modal__inner__box">
          <p className="person__show__modal__inner--semititle">
            {state.semititleSecond}
          </p>
          <TextBox
            className="person__show__modal__inner--textbox"
            placeholder="〇〇学部・〇〇学科"
            onChanged={(name, value) => onChangeBody('department', value)}
            name="department"
            value={state.department}
          />
        </div>
      )}
      {target === 'careerHistories' && (
        <>
          {/* 職種1 */}
          <div className="person__show__modal__inner__box mt">
            <p className="person__show__modal__inner--semititle">
              職種<span className="must">必須</span>
            </p>
            {state.position.length === 0 ? (
              <p
                className="person__show__modal__inner--textbox spacing"
                onClick={() => handleOpenSmallModal(0)}
              >
                タップして選択してください
              </p>
            ) : (
              <p
                className="person__show__modal__inner--textbox spacing size position"
                onClick={() => handleOpenSmallModal(0)}
              >
                {state.position[0].occupationDetailName !== '' ? (
                  <>
                    {state.position[0].occupationName}
                    <br />
                    {state.position[0].occupationDetailName}
                  </>
                ) : (
                  <>{state.position[0].occupationName}</>
                )}
              </p>
            )}
          </div>
          {/* 職種2 & 3（繰り返し） */}
          {[1, 2].map((index) => (
            <div
              key={index}
              className={`person__show__modal__inner__box mt occupation ${
                state.occupationCount > index - 1 ? 'active' : ''
              }`}
            >
              <p className="person__show__modal__inner--semititle">
                <div className="person__show__modal__inner__box occupation--title">
                  <span>職種({index + 1})</span>
                  <span onClick={() => handleDeleteOccuption(index)}>× 削除</span>
                </div>
              </p>
              {state.position.length <= index ? (
                <p
                  className="person__show__modal__inner--textbox spacing"
                  onClick={() => handleOpenSmallModal(index)}
                >
                  タップして選択してください
                </p>
              ) : (
                <p
                  className="person__show__modal__inner--textbox spacing size position"
                  onClick={() => handleOpenSmallModal(index)}
                >
                  {state.position[index].occupationName}
                  <br />
                  {state.position[index].occupationDetailName}
                </p>
              )}
            </div>
          ))}
          {/* 職種追加ボタン */}
          <div className="person__show__modal__inner__box">
            <p
              className={`add ${state.occupationCount > 1 ? 'disabled' : ''}`}
              onClick={handleAddOccuption}
            >
              <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
                <path
                  d="M3.53847 4.46152H0V3.53848H3.53847V0H4.46152V3.53848H8V4.46152H4.46152V8H3.53847V4.46152Z"
                  fill={state.occupationCount > 1 ? '#CCCCCC' : '#1B1464'}
                />
              </svg>
              職種を追加(最大3つ)
            </p>
          </div>
          {/* 職種モーダル */}
          <div className={`person__show__modal is-wide small ${state.modalSmall ? 'active is-height' : ''}`}>
            <h3 className="person__show__modal__title">
              <div onClick={() => handleOpenSmallModal(0)} className="mask">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12">
                  <path
                    d="M0.735395 12L0 11.2646L5.26461 6L0 0.735394L0.735395 0L6 5.26461L11.2646 0L12 0.735394L6.7354 6L12 11.2646L11.2646 12L6 6.73539L0.735395 12Z"
                    fill="#19190F"
                  />
                </svg>
              </div>
              <p className="title">職種</p>
            </h3>
            <div className="person__show__modal__inner">
              <p className="person__show__modal__inner--title">
                職種を選択して保存してください
                <span className="subtitle">※職種カテゴリーだけの選択も可能です</span>
              </p>
              {/* カテゴリ一覧 */}
              <div className="person__show__modal__inner__occupations">
                <ul className="person__show__modal__inner__location">
                  {state.suggestOccupations?.map((s) => (
                    <li key={s.name} data-id={s.id} className="suggetsBtn">
                      <button
                        type="button"
                        onClick={() => handleScrollTo(s.name)}
                        className="suggetsBtn__link"
                      >
                        {s.name}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
              {/* 詳細一覧 */}
              <div className="person__show__modal__inner__occupations--list" id="flexbox_top">
                {state.suggestOccupationDetails?.map((d) => (
                  <div key={d.occupationName} className="occupation--box">
                    <div
                      className={`flexbox ${
                        isCheckedPosition(true, d.occupationName) ? 'active' : ''
                      }`}
                      onClick={() => handleClickOccupations(d.occupationName, '', '')}
                    >
                      <p
                        id={`flexbox_${d.occupationName}`}
                        className="occupation--name pn"
                        data-id={d.occupationId}
                      >
                        {d.occupationName}
                      </p>
                      {isCheckedPosition(true, d.occupationName) && (
                        <svg width="14" height="10">
                          <path d="M4.885 9.897L0.219 5.23l0.896-0.896L4.885 8.105 12.885 0.105l0.896 0.896L4.885 9.897z" fill="#19190F" />
                        </svg>
                      )}
                    </div>
                    {d.occupationDetails.map((od) => (
                      <div
                        key={od.name}
                        className={`flexbox ${isCheckedPosition(false, od.id) ? 'active' : ''}`}
                        onClick={() => handleClickOccupations(od.occupationName, od.id, od.name)}
                      >
                        <p data-id={od.id} data-occupation_name={od.occupationName}>
                          {od.name}
                        </p>
                        {isCheckedPosition(false, od.id) && (
                          <svg width="14" height="10">
                            <path d="M4.885 9.897L0.219 5.23l0.896-0.896L4.885 8.105 12.885 0.105l0.896 0.896L4.885 9.897z" fill="#19190F" />
                          </svg>
                        )}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
              <div className="person__show__modal__submit single">
                <div className="btnCover">
                  <button onClick={handleCloseSmallModal} className="submit">
                    保存
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* 年収レンジ */}
          <div className="person__show__modal__inner__box">
            <p className="person__show__modal__inner--semititle">年収レンジ</p>
            <p
              className="person__show__modal__inner--textbox spacing fit-content"
              onClick={handleOpenSmallSubModal}
            >
              {state.salaryRange === '' ? 'タップして選択してください' : salaryWord()}
            </p>
          </div>
          <div className={`person__show__modal is-wide small ${state.modalSmallSub ? 'active is-height' : ''}`}>
            <h3 className="person__show__modal__title">
              <div onClick={handleOpenSmallSubModal} className="mask">
                <svg width="12" height="12">
                  <path d="M0.735 12L0 11.265 5.265 6 0 0.735 0.735 0 6 5.265 11.265 0 12 0.735 6.735 6 12 11.265 11.265 12 6 6.735 0.735 12Z" fill="#19190F" />
                </svg>
              </div>
              <p className="title">年収レンジ</p>
            </h3>
            <div className="person__show__modal__inner salary">
              <p className="person__show__modal__inner--title">
                この職歴の年収レンジを選択して保存してください
              </p>
              <ul className="person__show__modal__inner__list">
                {state.salaries?.map((salary) => (
                  <li
                    key={salary.title}
                    data-id={salary.id}
                    onClick={() => onChangeBody('salaryRange', { currentTarget: { dataset: { id: salary.id } } })}
                    className={`salary ${state.salaryRange === salary.id ? 'active' : ''}`}
                  >
                    {salary.title}
                    {state.salaryRange === salary.id && (
                      <svg width="14" height="10">
                        <path d="M4.885 9.897L0.219 5.23l0.896-0.896L4.885 8.105 12.885 0.105l0.896 0.896L4.885 9.897z" fill="#19190F" />
                      </svg>
                    )}
                  </li>
                ))}
              </ul>
            </div>
            <div className="person__show__modal__submit">
              <p onClick={handleClearSalary} className="clear">すべてクリア</p>
              <div className="btnCover">
                <button onClick={handleCloseSmallSubModal} className="submit">保存</button>
              </div>
            </div>
          </div>
        </>
      )}
      {/* 在籍期間 */}
      <div className="person__show__modal__inner__box">
        <p className="person__show__modal__inner--semititle">
          在籍期間
          {target === 'educationalHistories' && <span>※卒業予定年を含む</span>}
          <span className="must">必須</span>
        </p>
        <div className="person__show__modal__inner__box__wrapper">
          <div className="person__show__modal__inner__box__date">
            <select
              className="year"
              name="startDateYear"
              value={state.startDateYear || ''}
              onChange={(e) => onChangeDate('startDateYear', e)}
            >
              {startYearList.map((year) => (
                <React.Fragment key={year}>
                  <option value={year}>{year}</option>
                  {target === 'educationalHistories' && year === 2010 && (
                    <option value="" disabled>西暦</option>
                  )}
                  {target === 'careerHistories' && year === 2020 && (
                    <option value="" disabled>西暦</option>
                  )}
                </React.Fragment>
              ))}
            </select>
            <span>年</span>
          </div>
          <div className="person__show__modal__inner__box__date">
            <select
              className="month"
              name="startDateMonth"
              value={state.startDateMonth || ''}
              onChange={(e) => onChangeDate('startDateMonth', e)}
            >
              <option value="" disabled hidden>月</option>
              {[...Array(12)].map((_, i) => (
                <option key={i + 1} value={i + 1}>{i + 1}</option>
              ))}
            </select>
            <span>月</span>
          </div>
          <div className="person__show__modal__inner__box__date--devide">~</div>
          <div className="person__show__modal__inner__box__date--block">
            <div className="person__show__modal__inner__box__date">
              <select
                className="year endDates"
                name="endDateYear"
                value={state.currentWorking ? '' : state.endDateYear || ''}
                onChange={(e) => onChangeDate('endDateYear', e)}
              >
                {birthdayList.map((year) => (
                  <React.Fragment key={year}>
                    <option value={year}>{year}</option>
                    {target === 'educationalHistories' && year === 2010 && (
                      <option value="" disabled>西暦</option>
                    )}
                    {target === 'careerHistories' && year === 2020 && (
                      <option value="" disabled>西暦</option>
                    )}
                  </React.Fragment>
                ))}
              </select>
              <span className="endDates">年</span>
            </div>
            <div className="person__show__modal__inner__box__date">
              <select
                className="month endDates"
                name="endDateMonth"
                value={state.currentWorking ? '' : state.endDateMonth || ''}
                onChange={(e) => onChangeDate('endDateMonth', e)}
              >
                <option value="" disabled hidden>月</option>
                {[...Array(12)].map((_, i) => (
                  <option key={i + 1} value={i + 1}>{i + 1}</option>
                ))}
              </select>
              <span className="endDates">月</span>
            </div>
            {target === 'careerHistories' && (
              <label htmlFor="current-working" className="checkbox">
                <input
                  id="current-working"
                  type="checkbox"
                  className="checkbox-input"
                  checked={state.currentWorking}
                  onChange={(e) => onChangeBody('currentWorking', e.target.checked)}
                />
                現在働いている
              </label>
            )}
          </div>
        </div>
      </div>
      {/* 説明 */}
      <div className="person__show__modal__inner__box">
        <p className="person__show__modal__inner--semititle">{state.semititleThird}</p>
        <TextArea
          className="person__show__modal__inner--textarea small"
          placeholder={
            target === 'educationalHistories'
              ? '学校で学んだことなどを記入してください'
              : '業務内容や達成したことなどを記入してください'
          }
          name="description"
          value={state.descriptionRaw}
          onChanged={(name, value) => onChangeBody(name as keyof PersonShowModalHistoriesState, value)}
        />
      </div>
      {/* 削除 */}
      {!fromEntry && (
        <div className="person__show__modal__inner__box__btnCover">
          <div onClick={handleDeleteHistories} className="person__show__modal__inner__box__delete">
            この{target === 'careerHistories' ? '職歴' : '学歴'}を削除
          </div>
        </div>
      )}
    </div>
  );
};
